/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ResetClientUserAccessCredentials$Params {
  clientID: number;
  clientUserID: number;
}

export function ResetClientUserAccessCredentials(http: HttpClient, rootUrl: string, params: ResetClientUserAccessCredentials$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, ResetClientUserAccessCredentials.PATH, 'post');
  if (params) {
    rb.path('clientID', params.clientID, {});
    rb.path('clientUserID', params.clientUserID, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

ResetClientUserAccessCredentials.PATH = '/api/Clients/ResetClientUserAccessCredentials/{clientID}/{clientUserID}';
